// extracted by mini-css-extract-plugin
export default {"primary":"primary-Om0v12u0z1XydJo9YJ3R"};